
<modal :state="state" :index="index" @toggle-modal="emitHideModal">
  <div class="organization-modal" :slot="ModalStatus.Confirmation">
    <div class="logo">
      <img src="@assets/images/logo-formability.svg" alt="Loading Spinner">
    </div>
    <p>Choose an Organization</p>

    <scroll-area class="max">
      <matrix
        class="clear-table"
        :has-header="false"
        has-data>
        <template slot="table-body">
          <a :href="organization.url" class="c-row" :class="linkClasses(organization)" v-for="organization in organizations" :key="organization.id">
            <t-prefix size="45">
              <avatar :user=organization :current-user-id="organization.id" image-name="logo"></avatar>
            </t-prefix>
            <t-column class="row-title">
              {{ organization.name }}
            </t-column>
          </a>

          <hr>

          <button v-if="$can('createNewOrganization', user)" @click="createNewOrganization" class="c-row org-button">
            <t-prefix size="45">
              <icon class="plus"></icon>
            </t-prefix>
            <t-column class="row-title align-left">
              <span class="btn-link new">Create Organization</span>
            </t-column>
            <t-suffix>
              <icon class="arrow-chevron right"></icon>
            </t-suffix>
          </button>

          <button @click="joinOrganization" class="c-row org-button">
            <t-prefix size="45">
              <icon class="organization"></icon>
            </t-prefix>
            <t-column class="row-title align-left">
              <span class="btn-link existing">Join an Existing Organization</span>
            </t-column>
            <t-suffix>
              <icon class="arrow-chevron right"></icon>
            </t-suffix>
          </button>

        </template>
      </matrix>
    </scroll-area>

  </div>
</modal>
